<template>
  <ItemDialog ref="dialogRef" image-type="alert">
    <template #content-area>
      <h2>予約の取り消し</h2>
      <p style="text-align: center">予約を取り消します。よろしいですか？</p>
    </template>
    <template #button-area>
      <ItemButton
        label="予約取り消し"
        action-type="btn-primary"
        @clicked="cancel()"
      />
      <ItemButton
        label="キャンセル"
        action-type="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>

  <!-- ローディングダイアログ(取り消し処理中) -->
  <DialogLoading ref="DialogLoading" />

  <!-- 取り消し完了のダイアログ -->
  <DialogCompleteReservationCancel ref="DialogCompleteReservationCancel" />
</template>

<script>
import { ref } from "vue";

import API from "@/API";

export default {
  name: "DialogConfirmReservationCancel",
  setup() {
    const dialogRef = ref(null);
    const DialogLoading = ref(null);
    const DialogCompleteReservationCancel = ref(null);

    const openDialog = () => {
      dialogRef.value.open();
    };

    const closeDialog = () => {
      dialogRef.value.close();
    };

    const cancel = async () => {
      closeDialog();
      try {
        DialogLoading.value.openDialog();
        await API.deleteDbsReservation();
        DialogLoading.value.closeDialog();
        DialogCompleteReservationCancel.value.openDialog();
      } catch (e) {
        DialogLoading.value.closeDialog();
      }
    };

    return {
      dialogRef,
      openDialog,
      closeDialog,
      cancel,
      DialogLoading,
      DialogCompleteReservationCancel,
    };
  },
};
</script>
